import React from 'react';
import SetupConnectObjectPage from './SetupConnectObjectPage';

const SetupQuickConnectPage = () => (
  <SetupConnectObjectPage
    pageTitle="Setup Quick Connect"
    pageSubtitle="Upload JSON to create quick connects for a selected Amazon Connect instance"
    objectLabel="Quick Connect"
    endpointKey="quickConnectApi"
    presignType="quick-connect"
    sampleFile="sample_quick_connect_upload.json"
    acceptedKeys={["quick_connects", "items"]}
    requiredFields={["Name", "QuickConnectConfig"]}
  />
);

export default SetupQuickConnectPage;
